const StatusEnum = {
  Draft: {
    id: 1,
    nameEn: "Draft",
    type: "EstimateStatus",
    nameFr: "",
  },
  Submitted: {
    id: 2,
    nameEn: "Submitted",
    type: "EstimateStatus",
    nameFr: "",
  },
  Accepted: {
    id: 3,
    nameEn: "Accepted",
    type: "EstimateStatus",
    nameFr: "",
  },
  Rejected: {
    id: 4,
    nameEn: "Rejected",
    type: "EstimateStatus",
    nameFr: "",
  },
  NotStarted: {
    id: 13,
    nameEn: "Not Started",
    type: "WOStatus",
    nameFr: "",
  },
  InProgress: {
    id: 14,
    nameEn: "In Progress",
    type: "WOStatus",
    nameFr: "",
  },
  OnHold: {
    id: 15,
    nameEn: "On Hold",
    type: "WOStatus",
    nameFr: "",
  },
  Completed: {
    id: 16,
    nameEn: "Completed",
    type: "WOStatus",
    nameFr: "",
  },
  Closed: {
    id: 17,
    nameEn: "Closed",
    type: "WOStatus",
    nameFr: "",
  },
  Waiting: {
    id: 18,
    nameEn: "Waiting",
    type: "TechnicianStatus",
    nameFr: "En attendant",
  },
  Approved: {
    id: 19,
    nameEn: "Approved",
    type: "TechnicianStatus",
    nameFr: "Approuvé",
  },
  Declined: {
    id: 20,
    nameEn: "Declined",
    type: "TechnicianStatus",
    nameFr: "Refusé",
  },
  OnMyWay: {
    id: 21,
    nameEn: "On My Way",
    type: "AppointmentStatus",
    nameFr: "En route",
  },
  NotStarted: {
    id: 22,
    nameEn: "Not Started",
    type: "AppointmentStatus",
    nameFr: "Non commencé",
  },
  InProgress: {
    id: 23,
    nameEn: "In Progress",
    type: "AppointmentStatus",
    nameFr: "En cours",
  },
  Completed: {
    id: 24,
    nameEn: "Completed",
    type: "AppointmentStatus",
    nameFr: "Terminé",
  },
  TechDeclined: {
    id: 25,
    nameEn: "Declined",
    type: "AppointmentStatus",
    nameFr: "Refusé",
  },
  Cancelled: {
    id: 26,
    nameEn: "Cancelled",
    type: "AppointmentStatus",
    nameFr: "Annulé",
  },
  Started: {
    id: 27,
    nameEn: "Started",
    type: "AppointmentStatus",
    nameFr: "Commencé",
  },
  Paused: {
    id: 28,
    nameEn: "Paused",
    type: "AppointmentStatus",
    nameFr: "En pause",
  },
  InvoiceDraft: {
    id: 29,
    nameEn: "Draft",
    type: "InvoiceStatus",
    nameFr: "Brouillon",
  },
  InvoiceSent: {
    id: 30,
    nameEn: "Sent",
    type: "InvoiceStatus",
    nameFr: "Envoyé",
  },
  InvoiceUnpaid: {
    id: 31,
    nameEn: "Unpaid",
    type: "InvoiceStatus",
    nameFr: "Impayé",
  },
  InvoicePartiallyPaid: {
    id: 32,
    nameEn: "Partially Paid",
    type: "InvoiceStatus",
    nameFr: "Partiellement payé",
  },
  InvoiceFullyPaid: {
    id: 33,
    nameEn: "Fully Paid",
    type: "InvoiceStatus",
    nameFr: "Entièrement payé",
  },
  InvoiceCancelled: {
    id: 34,
    nameEn: "Cancelled",
    type: "InvoiceStatus",
    nameFr: "Annulé",
  },
  Resumed: {
    id: 35,
    nameEn: "Resumed",
    type: "AppointmentStatus",
    nameFr: "Repris",
  },
};

export default StatusEnum;
